module.exports = __webpack_public_path__ + "static/img/gxg_03.cb81687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_03.png
// module id = Axl4
// module chunks = 46